export enum FlashMessagesActionTypes {
  ADD_MESSAGE,
  REMOVE_MESSAGE
}
